import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SquirrelEnvironmentDto } from 'shared';
import { DatabaseMigrationService } from 'shared';
import { NotificationService } from 'shared';
import { TranslateService } from 'shared';

@Component({
    selector: 'update-squirrel-environment-dialog',
    templateUrl: './update-squirrel-environment-dialog.component.html',
    styleUrls: ['./update-squirrel-environment-dialog.component.css'],
    standalone: false
})
export class UpdateSquirrelEnvironmentDialogComponent implements OnInit {

  squirrelEnvironmentForm!: UntypedFormGroup;
  environmentDto!: SquirrelEnvironmentDto;

  constructor(private fb: UntypedFormBuilder,
    public dialogRef: MatDialogRef<UpdateSquirrelEnvironmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private databaseMigrationService: DatabaseMigrationService,
    public translate: TranslateService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    console.log(this.data)
    this.createsquirrelEnvironmentForm();
  }

  createsquirrelEnvironmentForm() {
    this.squirrelEnvironmentForm = this.fb.group({
      id: [this.data.id],
      name: [this.data.name],
      url: [this.data.url],
      // numberOfMigrations: [this.data.numberOfMigrations],
      // migratedWhen: [this.data.migratedWhen]
    });
  }

  update() {  
    if(this.squirrelEnvironmentForm.valid) {

      let environmentDto = new  SquirrelEnvironmentDto;
      
      environmentDto.id = this.squirrelEnvironmentForm.value.id;
      environmentDto.name = this.squirrelEnvironmentForm.value.name;
      environmentDto.url = this.squirrelEnvironmentForm.value.url;
      // environmentDto.migratedWhen = this.squirrelEnvironmentForm.value.migratedWhen;
      // environmentDto.numberOfMigrations = this.squirrelEnvironmentForm.value.numberOfMigrations;

      console.log(environmentDto);

      this.databaseMigrationService.updateSquirrelEnvironment(environmentDto).subscribe({
        next: (data) => {          
        }
      });      
      this.dialogRef.close(this.squirrelEnvironmentForm.value);
    }
  }

  cancel(){
    this.dialogRef.close();
  }
}

